import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import MediaSnapshot from './media-snapshot-model'
import {
  CreateMediaSnapshotAsync,
  DeleteMediaSnapshotAsync,
  LoadMediaSnapshotsAsync,
} from './mediaSnapshot-thunk'
const initialState: mediaSnapshotSliceState = {
  mediaSnapshot: [],
  selected_mediaSnapshot: '',
  is_loading_mediaSnapshot: false,
  is_creating_mediaSnapshot: false,
  is_deleting_mediaSnapshot: false,
}
export interface mediaSnapshotSliceState {
  mediaSnapshot: MediaSnapshot[]
  selected_mediaSnapshot?: string
  is_loading_mediaSnapshot: boolean
  is_creating_mediaSnapshot: boolean
  is_deleting_mediaSnapshot: boolean
}
export const mediaSnapshotSlice = createSlice({
  name: 'mediaSnapshot',
  initialState,
  reducers: {
    setSelectedmediaSnapshot: (state, action) => {
      state.selected_mediaSnapshot = action.payload
    },
    clearStatemediaSnapshot: (state) => {
      state.mediaSnapshot = []
      state.is_loading_mediaSnapshot = false
      state.is_creating_mediaSnapshot = false
      state.is_deleting_mediaSnapshot = false
    },
    mergemediaSnapshot: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_mediaSnapshot = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.mediaSnapshot = merge(state.mediaSnapshot, payload) as any
        }
      }
    },

    add_mediaSnapshot: (state, action) => {
      if (action.payload) {
        state.mediaSnapshot = [...state.mediaSnapshot, action.payload]
      }
    },
    set_mediaSnapshot: (state, action) => {
      let { key, value, id } = action.payload
      state.mediaSnapshot = state.mediaSnapshot.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadMediaSnapshotsAsync.pending, (state) => {
      state.is_loading_mediaSnapshot = true
    })
    builder.addCase(LoadMediaSnapshotsAsync.fulfilled, (state, action) => {
      state.is_loading_mediaSnapshot = false
      if (action.payload) {
        state.mediaSnapshot = action.payload
      }
    })
    builder.addCase(LoadMediaSnapshotsAsync.rejected, (state) => {
      state.is_loading_mediaSnapshot = false
    })
    builder.addCase(CreateMediaSnapshotAsync.pending, (state) => {
      state.is_creating_mediaSnapshot = true
    })
    builder.addCase(CreateMediaSnapshotAsync.fulfilled, (state) => {
      state.is_creating_mediaSnapshot = false
    })
    builder.addCase(CreateMediaSnapshotAsync.rejected, (state) => {
      state.is_creating_mediaSnapshot = false
    })
    builder.addCase(DeleteMediaSnapshotAsync.pending, (state) => {
      state.is_deleting_mediaSnapshot = true
    })
    builder.addCase(DeleteMediaSnapshotAsync.fulfilled, (state, action) => {
      state.is_deleting_mediaSnapshot = false
      if (state.mediaSnapshot) {
        state.mediaSnapshot = state.mediaSnapshot.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteMediaSnapshotAsync.rejected, (state) => {
      state.is_deleting_mediaSnapshot = false
    })
  },
})

export const {
  clearStatemediaSnapshot,
  setSelectedmediaSnapshot,
  set_mediaSnapshot,
  mergemediaSnapshot,
  add_mediaSnapshot,
} = mediaSnapshotSlice.actions

export const get_mediaSnapshot =
  (id?: string) =>
  (state: {
    mediaSnapshot: {
      mediaSnapshot: MediaSnapshot[]
    }
  }): MediaSnapshot | null => {
    let temp = state?.mediaSnapshot?.mediaSnapshot?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.mediaSnapshot?.mediaSnapshot[0] || null
  }
export const get_selected_mediaSnapshot = (state: {
  mediaSnapshot: mediaSnapshotSliceState
}): MediaSnapshot | null => {
  let id = state?.mediaSnapshot?.selected_mediaSnapshot
  let temp = state?.mediaSnapshot?.mediaSnapshot?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_mediaSnapshot = (state: {
  mediaSnapshot: {
    mediaSnapshot: MediaSnapshot[]
  }
}): MediaSnapshot[] => {
  let temp = state?.mediaSnapshot?.mediaSnapshot
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_mediaSnapshot_busy = (state: {
  mediaSnapshot: mediaSnapshotSliceState
}) => {
  return (
    state?.mediaSnapshot.is_deleting_mediaSnapshot ||
    state?.mediaSnapshot.is_loading_mediaSnapshot ||
    state?.mediaSnapshot.is_creating_mediaSnapshot
  )
}
export const is_deleting_mediaSnapshot_busy = (state: {
  mediaSnapshot: mediaSnapshotSliceState
}) => {
  return state?.mediaSnapshot.is_deleting_mediaSnapshot
}
export const is_loading_mediaSnapshot_busy = (state: {
  mediaSnapshot: mediaSnapshotSliceState
}) => {
  return state?.mediaSnapshot.is_loading_mediaSnapshot
}
export const is_creating_mediaSnapshot_busy = (state: {
  mediaSnapshot: mediaSnapshotSliceState
}) => {
  return state?.mediaSnapshot.is_creating_mediaSnapshot
}

export default mediaSnapshotSlice.reducer
